 export function formatFirestoreTStoDate(ts: any) {
    const date:any = ts?.toDate(); 

    const day = date?.getDate()
    const month = date?.toLocaleString("en-us", { month: "short" })
    const year = date?.getFullYear()

    return  day&&month&&year?`${month||""} ${day}, ${year}`:null

 }
  
  export   function formatUSNumber(num:any) {
  return new Intl.NumberFormat("en-US").format(num)||0;
}
